import * as _ from 'lodash';
import { MapEpicStates } from './States/map.epic.states';

export namespace ActionsManager {
    export class Manager {
        public actions: any = {};
        public constructor() { }

        public register(newactions: any) {
            _.mixin(this.actions, newactions);
        }
    }

    export function factory(): Manager {
        const manager = new Manager();
        manager.register(MapEpicStates.actions());
        return manager;
    }
}
